export const EXPERIENCE_PENDING = 'pending' as const;
export const EXPERIENCE_FAILED = 'failed' as const;
export const EXPERIENCE_SUCCEEDED = 'succeeded' as const;

export type ExperienceResult =
	| typeof EXPERIENCE_PENDING
	| typeof EXPERIENCE_FAILED
	| typeof EXPERIENCE_SUCCEEDED;
